import { PartnerFlagRequestStatus } from 'clickNgo/entities/partner/models'

export const DATE_PICKER_MODE = 'single'
export const UNPROCESSED_STATUS = [
  PartnerFlagRequestStatus.Done,
  PartnerFlagRequestStatus.Rejected,
  PartnerFlagRequestStatus.WIP,
]
export const DEFAULT_DATE = new Date()
